import { SEARCH } from 'reporting-data/constants/configTypes';
import { getDimensions, getMetricProperties } from 'reporting-data/report/configReportGetters';
import { isUnifiedEventsQLReport } from 'reporting-data/tsTypes/reportTypes';
import { getIsReportValidForBreakdownEditorDropdown } from '../breakdown-editor-dropdown/utils';
import { getIsReportValidForDimensionEditorDropdown } from '../dimension-editor-dropdown/utils';
import { getIsReportValidForMetricsEditorDropdown } from '../metrics-editor-dropdown/utils';
export const isUEQLSearchConfig = report => isUnifiedEventsQLReport(report) && report.getIn(['config', 'configType']) === SEARCH;
export const isReportValidForDataColumnsModal = (report, userInfo) => {
  return getIsReportValidForMetricsEditorDropdown({
    report,
    userInfo
  }) || getIsReportValidForDimensionEditorDropdown({
    report,
    userInfo
  }) || getIsReportValidForBreakdownEditorDropdown({
    report,
    userInfo
  }) || isUEQLSearchConfig(report);
};
export const getPropertiesFromConfigReportForDataColumnsModal = report => {
  const dimensions = getDimensions(report).toJS() || [];
  const metricProperties = getMetricProperties(report).toJS() || [];
  return dimensions.concat(metricProperties);
};